const STORAGE_KEY = 'ponyup-announcer';

/**
 * Whether this device reads bets out loud.
 *
 * Module scope, not component state, because the part that speaks and the
 * switch that controls it now live on different screens. Two copies of a
 * useState would disagree the moment both were mounted -- the same mistake that
 * made the update prompt appear repeatedly.
 *
 * Per device on purpose: this is for the phone sitting on a speaker, not for
 * everyone's pocket at once.
 */
let enabled = (() => {
    try {
        return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
})();

const listeners = new Set<() => void>();

export const isAnnouncerEnabled = (): boolean => enabled;

export const setAnnouncerEnabled = (next: boolean): void => {
    enabled = next;
    try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
        // A blocked store just means the choice does not survive a reload.
    }
    if (!next) window.speechSynthesis?.cancel();
    listeners.forEach((listener) => listener());
};

export const subscribeToAnnouncer = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const announcerSupported = (): boolean =>
    typeof window !== 'undefined' && 'speechSynthesis' in window;
